export default {
    AUD: 'Australian Dollars',
    CAD: 'Canadian Dollars',
    EUR: 'Euros',
    GBP: 'Pound Sterling',
    MXN: 'Mexican Pesos',
    USD: 'US Dollars',
    ZAR: 'South African Rand'
};